import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const {
  endpoints: {
    account: { resetPassword: url },
  },
} = config

/**
 * Actualizar el nuevo password.
 *
 * @param {String} data.password User password
 */
export const newPassword = (token, data) => axios.put(`${url}?token=${token}`, data, { headers: getHeaders() })

/**
 * Peticion de reseteo de nuevo password.
 *
 * @param {String} data.email User email
 */
export const resetPassword = (data) => axios.post(url, data, { headers: getHeaders() })
